export default __webpack_public_path__ + "static/media/icon_messages_pressed..fddb4ba3.svg";